import { Grid } from '@mui/material'
import { TFunction } from 'next-i18next'
import React from 'react'
import Descriptions from './Descriptions'
import Resources from './Resources'

const Press = (props: Props) => {
  const { t, strings } = props;

  return (
    <section className="sectionPadding centerContent">
      <h1>{strings.press}</h1>
      <p>{strings.press_description}</p>

      <Grid container spacing={5}>
        <Descriptions t={t} />
        <Resources t={t} />
      </Grid>
    </section>
  )
}

interface Props {
  t: TFunction
  strings: any
}

export default Press
